import React, { useEffect } from 'react';
import { OptionKey, useWatch } from '@common-fe/common-fe';

import { useGetRoleByIdQuery } from '@/modules/role/queries';

import { useRoleSetupStore } from '../../stores';

import PermissionsSection from './PermissionsSection';

interface Props {
  isCopyMode?: boolean;
  onChangeValues?: (keys: OptionKey[]) => void;
}
const RolePermissions: React.FC<Props> = ({ isCopyMode, onChangeValues }) => {
  const copyRoleId: string = useWatch({
    name: 'copyRoleId'
  });

  const { data, isLoading } = useGetRoleByIdQuery({ id: copyRoleId});
  const setState = useRoleSetupStore((state) => state.setState);
  
  useEffect(() => {
    if(copyRoleId && data?.granted) {
      
      const ids = data?.granted.reduce((result: OptionKey[], item) => {
        const currentIds = item.options.map((option) => option.id);
        return [...result, ...currentIds];
      }, []);
      if(onChangeValues) {
        onChangeValues(ids);
      } else {
        setState({
          permissions: ids
        });
      }
    } else {
      if(!onChangeValues) {
        setState({
          permissions: []
        }); 
      }
    }
  }, [data?.granted, copyRoleId, setState, onChangeValues]);
  
  if(!copyRoleId) {
    return null;
  }
  return (
    <PermissionsSection
      isCopyMode={isCopyMode}
      isSearchLess
      granted={data?.granted}
      revoked={data?.revoked}
      isLoading={isLoading} />
  );
};

export default RolePermissions;